import React, { useState, useEffect, useCallback } from 'react'
import Select, {Async} from 'react-select'
import styled from 'styled-components'
import i18n from 'live/services/i18n'
import debounce from 'lodash.debounce';

export enum InputType {
    SELECT = 'SELECT',
    TEXT = 'TEXT',
    NUMBER = 'NUMBER',
    DATE = 'DATE'
}

export type Option = {
    value: string
    label: string
}

type Filter = {
    title?: string
    type?: InputType
    options?: Option[],
    handleQuery?(query: string): any
}

type IProps = {
    filters: any[]
    filtersActive?: any,
    debounceTime?: number,
    callbackChange?(filtersActive: Filter): void
    clearFilters?: boolean
}

export const buildBody = (filtersActive: Filter): any => {
    const bodyRequest = []

    if (filtersActive) {
        Object.keys(filtersActive).map(key => {
            const obj = filtersActive[key]
            const objBody: any = { operation: 'OR', nodes: [] }

            obj.values.forEach(ele => objBody.nodes.push(ele.value))

            bodyRequest.push(objBody)
        })
    }

    return bodyRequest
}

export const FiltersPipes = ({ filters = [], filtersActive, debounceTime = 700, callbackChange, clearFilters }: IProps): JSX.Element => {
    const [filtersSelected, setFiltersSelected] = useState<any>({})

    useEffect(() => {
        if (filtersActive !== undefined) {
            setFiltersSelected(filtersActive)
        }
    }, [filtersActive])

    useEffect(() => {
        if (clearFilters === true) setFiltersSelected({})
    }, [clearFilters])

    

    const changeFilter = (target, key) => {
        const obj = { ...filtersSelected }

        if (!obj[key]) obj[key] = { values: undefined }

        obj[key].values = target

        if (obj[key]?.values?.length === 0) {
            delete obj[key]
        }

        setFiltersSelected(obj)
        callbackChange(obj)
    }

    const getOptions = useCallback((input, callback, handleQuery) => {
        handleQuery(input).then(result => {
            callback(null, {
                options: result,                          
                complete: false
            })
        })
      }, []);


    return (
        <>
            {filters.map((ele, index) => {
                const { type, title, field, options, handleQuery, multi = true } = ele

                return (
                    <ContainerSelect key={index}>
                        <div className="wrapper-select">
                            <label>{title}</label>
        
                            {
                                handleQuery 
                                ?
                                <Async
                                        name={field}
                                        multi={multi}
                                        value={filtersSelected[field]?.values}
                                        loadOptions={(input, callback) => getOptions(input, callback, handleQuery)}
                                        onChange={target => {
                                            changeFilter(target, field)
                                        }}                       
                                    />
                                :
                                    <Select
                                        menuIsOpen={true}
                                        multi={multi}
                                        value={filtersSelected[field]?.values}
                                        onChange={target => {
                                            changeFilter(target, field)
                                        }}
                                        name={field}
                                        options={options}                                
                                    />
                            }
                        </div>
        
                    </ContainerSelect>
                )
            })}
        </>
    )
}

export default React.memo(FiltersPipes)

const ContainerSelect = styled.div`
    margin-bottom: 12px;
`
